import React from "react"
import NavbarM from './NavBarM'
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import InputGroup from 'react-bootstrap/InputGroup'
import axiosInstance from '../axiosInstance'



const definitions = {
    'სხვა':'other',
    'ახალი STB':'new_stb',
    'შესაცვლელია STB':'replace_stb',
    "წამოსაღებია STB":'remove_stb',
    "შესაცვლელია პულტი":'replace_remote',
}
class UpdateModal extends React.Component{

    constructor(props){
        super()
        this.state= {
            billing_number:props.data[0],
            first_name:props.data[7],
            last_name:props.data[8],
            address:props.data[9],
            definition:definitions[props.data[1]],
            phone:props.data[11],
            comment:props.data[12],
            city:props.data[10],
            errors:{
                billing_number:false,
                first_name:false,
                last_name:false,
                definition:false,
                city:false
            },
            modal:false,
            error_messages:{
                billing_error_message:'გთხოვთ შეიყვანოთ საბილინგო ნომერი',
                first_name_error_message:'გთხოვთ შეიყვანოთ სახელი',
                last_name_error_message:'გთხოვთ შეიყვანოთ გვარი',
                phone_error_message:'გთხოვთ შეიყვანოთ მობილური',
                address_error_message:'გთხოვთ შეიყვანოთ მისამართი',
                city_error_message:'გთხოვთ შეიყვანოთ ქალაქი'
            }
        }
    }
    onChange(event){
        this.setState(
            {[event.target.name]:event.target.value,
                errors:{
                    ...this.state.errors,
                    [event.target.name]:false 
                }
            }
        )
    }


    valid(){
        var billing = (this.state.billing_number === '')
        var firstname = (this.state.first_name === '');
        var secondname =(this.state.last_name === '');
        var address = (this.state.address === '');
        var phone = (this.state.address === '');
        var city = (this.state.city === '')
        if(billing || firstname || secondname || address || phone){
            this.setState({
                errors:{
                    billing_number:billing,
                    first_name:firstname,
                    last_name:secondname,
                    address:address,
                    phone:phone,
                    city:city
                },
                error_messages:{
                    ...this.state.error_messages,
                    billing_error_message:'გთხოვთ შეიყვანოთ საბილინგო ნომერი'
                }
            })
            return false;
        }
        return true;
    }
    afterInsert(data){
        this.setState({
            ...this.state,
            modal:true
        })
    }

    sendData(){
        var data = new FormData();
        data.append('action','update');
        data.append('billing_number',this.state.billing_number);
        data.append('first_name', this.state.first_name);
        data.append('last_name', this.state.last_name);
        data.append('definition', this.state.definition);
        data.append('phone', this.state.phone);
        data.append('comment', this.state.comment);
        data.append('address',this.state.address);
        data.append('city',this.state.city)
        if(this.valid()){
            axiosInstance.post("api.php",data)
            .then(data =>this.afterInsert(data))
            .catch(err => console.log("error: "+err))
        }
    }

    afterBillingFetch(data){
        this.setState({
            ...this.state,
            first_name:data.data.first_name,
            last_name:data.data.last_name,
            address:data.data.address,
            phone:data.data.phone,
            city:data.data.city
        })
    }


    logout(){
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        this.props.history.push('/login')
    }

    fetchBillingInfo(){
        if(this.state.billing_number === ''){
            this.setState({
                errors:{
                    ...this.state.errors,
                    billing_number:true
                }
            })
            return;
        }
        axiosInstance.get("api.php", {params: {
            action: "billing_info",
            billing_number: this.state.billing_number
        }})
        .then(data =>this.afterBillingFetch(data))
        .catch(err =>  {
            if(err.response.status === 401){
                this.logout();
            }
            if(err.response.status === 400){
                this.setState({
                    ...this.state,
                    errors:{
                        ...this.state.errors,
                        billing_number:true
                    },
                    error_messages:{
                        ...this.state.error_messages,
                        billing_error_message:'მონაცემები ვერ მოიძებნა'
                    }
                })
            }
        }
           
        )
    }

    modalClose(){
        this.setState({
            billing_number:'',
            first_name:'',
            last_name:'',
            address:'',
            definition:'',
            phone:'',
            comment:'',
            city:'',
            errors:{
                billing_number:false,
                first_name:false,
                last_name:false,
                definition:false,
                address:false,
                city:false
            },
            modal:false
        })
    }
    render(){
        return (
            <div>
                <NavbarM user = {1}/>
                <div className="container">
                    <Form.Row >
                        <Form.Group as={Col} md="4" controlId="validationFormik03">
                            <Form.Label>საბილინგო ნომერი</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="number"
                                    name="billing_number"
                                    onChange = {(event)=>this.onChange(event)}
                                    isInvalid = {Boolean(this.state.errors.billing_number)}
                                    value = {this.state.billing_number}
                                />
                                <Form.Control.Feedback type="invalid" >
                                    {this.state.error_messages.billing_error_message}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="validationFormik01">
                            <Form.Label>სახელი</Form.Label>
                            <Form.Control
                                type="text"
                                name="first_name"
                                onChange = {(event)=>this.onChange(event)}
                                isInvalid = {Boolean(this.state.errors.first_name)}
                                value = {this.state.first_name}
                            />
                            <Form.Control.Feedback type="invalid" >
                            {this.state.error_messages.first_name_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col}  md="4" controlId="validationFormik02">
                            <Form.Label>გვარი</Form.Label>
                            <Form.Control
                                type="text"
                                name="last_name"
                                onChange = {(event)=>this.onChange(event)}
                                isInvalid = {Boolean(this.state.errors.last_name)}
                                value = {this.state.last_name}
                            />
                            <Form.Control.Feedback type="invalid" >
                            {this.state.error_messages.last_name_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="3" controlId="validationFormik010">
                            <Form.Label>ქალაქი</Form.Label>
                            <Form.Control
                                type="text"
                                name="city"
                                onChange = {(event)=>this.onChange(event)}
                                isInvalid = {Boolean(this.state.errors.city)}
                                value = {this.state.city}
                            />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.city_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="6" controlId="validationFormik04">
                            <Form.Label>მისამართი</Form.Label>
                            <Form.Control
                                type="text"
                                name="address"
                                onChange = {(event)=>this.onChange(event)}
                                isInvalid = {Boolean(this.state.errors.address)}
                                value = {this.state.address}
                            />
                             <Form.Control.Feedback type="invalid" >
                             {this.state.error_messages.address_error_message}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="validationFormik03">
                            <Form.Label>მობილური</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="number"
                                    name="phone"
                                    onChange = {(event)=>this.onChange(event)}
                                    isInvalid = {Boolean(this.state.errors.phone)}
                                    value = {this.state.phone}
                                />
                                <Form.Control.Feedback type="invalid" >
                                {this.state.error_messages.phone_error_message}
                                </Form.Control.Feedback>
                            </InputGroup>
                            
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col}  md="8" controlId="validationFormik05">
                            <Form.Label>კომენტარი</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="comment"
                                    onChange = {(event)=>this.onChange(event)}
                                    value = {this.state.comment}
                                />     
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="validationCustomUsername">
                            <Form.Label>აღწერა</Form.Label>
                            <InputGroup>
                                <Form.Control as="select" name = "definition"
                                onChange = {(event)=>this.onChange(event)} value={this.state.definition}
                                >
                                    <option value="other" defaultValue>სხვა</option>
                                    <option value="new_stb">ახალი STB</option>
                                    <option value="replace_stb">შესაცვლელია STB</option>
                                    <option value="remove_stb">წამოსაღებია STB</option>
                                    <option value="replace_remote_new">ახალი პულტი</option>
                                    <option value="replace_remote_secondary">მეორადი პულტი</option>
                                    <option value="replace_charger">კვების ბლოკის შეცვლა</option>
                                    <option value="replace_hdmi_wire">HDMI კაბელის შეცვლა</option>
                                    <option value="replace_rci_wire">RCI კაბელის შეცვლა</option>
                                    <option value="replace_ethernet_wire">Ethernet კაბელის შემოწმება/შეცვლა</option>
                                    <option value="presentation">პრეზენტაცია</option>
                                </Form.Control>
                            </InputGroup>
                        </Form.Group>
                    </Form.Row>
                </div>
            </div>
            
        );
    }
}
export default UpdateModal ;